import { SkeletonLoading } from "react-migration/components/SkeletonLoading";

export const LoadingSection = ({ rows, height }: { rows: number; height: string }) => (
  <div className="relative" style={{ height }}>
    <SkeletonLoading showPadding={false} rows={rows} bgClassName="bg-transparent" />
  </div>
);
